import { Link } from "react-router-dom";

export function GearsPage() {
	return (
		<div className="mx-auto max-w-2xl space-y-10 pb-16">
			<header className="space-y-2">
				<p className="font-geist text-wi-text/50 text-xs uppercase tracking-[0.14em]">Inspect the gears</p>
				<h1 className="font-newsreader text-wi-text text-3xl tracking-tight md:text-4xl">How WorthyIdea is built</h1>
				<p className="font-geist text-wi-text/72 text-sm leading-relaxed">
					A public slice of the system design — enough to orient engineers and security reviewers without needing
					access to the private repository.
				</p>
			</header>

			<section className="space-y-4 font-geist text-wi-text/78 text-sm leading-relaxed">
				<h2 className="font-newsreader text-wi-text text-xl tracking-tight">Edge &amp; data</h2>
				<ul className="list-disc space-y-2 pl-5">
					<li>
						<strong className="text-wi-text">Cloudflare Workers</strong> serve the React app and handle{" "}
						<code className="rounded bg-wi-bg px-1 text-xs">/api/*</code> HTTP routes.
					</li>
					<li>
						Each poll room has a <strong className="text-wi-text">Durable Object</strong> for live WebSocket state,
						presence, and authoritative tallies while voting is open.
					</li>
					<li>
						<strong className="text-wi-text">D1 (SQLite)</strong> stores room metadata, options, committed votes,
						and finalized snapshots — the durable record after the room settles or expires.
					</li>
					<li>
						The DO never writes D1 directly; it calls <strong className="text-wi-text">internal Worker routes</strong>{" "}
						with a shared secret so checkpoints stay auditable and centralized.
					</li>
				</ul>
			</section>

			<section className="space-y-4 font-geist text-wi-text/78 text-sm leading-relaxed">
				<h2 className="font-newsreader text-wi-text text-xl tracking-tight">Trust borders</h2>
				<ul className="list-disc space-y-2 pl-5">
					<li>
						<strong className="text-wi-text">Browser ↔ Worker</strong> — TLS; same-origin API and WebSocket; CSP on
						the SPA shell.
					</li>
					<li>
						<strong className="text-wi-text">Voter ↔ Curator</strong> — separate invitation vs Curator Link URLs; voters
						never receive Curator capability.
					</li>
					<li>
						<strong className="text-wi-text">DO ↔ Worker</strong> — privileged D1 writes go through an internal secret;
						the Durable Object does not hold D1 bindings.
					</li>
					<li>
						<strong className="text-wi-text">Honesty on retention</strong> — this consumer site{" "}
						<em>does</em> persist ballots in D1 for the room TTL so Curator Links can recover. Host-native flows that
						commit a Consensus Record and clear temporary session memory are a separate track — see{" "}
						<Link to="/trust/security" className="font-medium text-wi-gold underline-offset-2 hover:underline">
							Trust Center
						</Link>
						.
					</li>
				</ul>
			</section>

			<section className="space-y-4 font-geist text-wi-text/78 text-sm leading-relaxed">
				<h2 className="font-newsreader text-wi-text text-xl tracking-tight">Curator trust</h2>
				<p>
					The <strong className="text-wi-text">Curator Link</strong> in the URL is hashed at rest. After you verify
					once, an HttpOnly cookie can spare you from pasting the link on every visit — but the Curator Link remains the
					recovery credential if the cookie is lost.
				</p>
			</section>

			<section className="space-y-4 font-geist text-wi-text/78 text-sm leading-relaxed">
				<h2 className="font-newsreader text-wi-text text-xl tracking-tight">Where to go next</h2>
				<ul className="list-disc space-y-2 pl-5">
					<li>
						<Link to="/security" className="font-medium text-wi-gold underline-offset-2 hover:underline">
							Security controls matrix
						</Link>{" "}
						— implemented vs roadmap by area.
					</li>
					<li>
						<Link to="/trust/security" className="font-medium text-wi-gold underline-offset-2 hover:underline">
							Trust Center · Security
						</Link>{" "}
						— encryption, minimization, and enterprise narrative.
					</li>
					<li>
						<Link to="/help" className="font-medium text-wi-gold underline-offset-2 hover:underline">
							Help
						</Link>{" "}
						— how teams run sessions day to day.
					</li>
				</ul>
			</section>

			<p className="pt-6">
				<Link
					to="/about"
					className="font-geist text-wi-text/55 text-sm underline-offset-2 transition-colors duration-150 ease-in-out hover:text-wi-gold hover:underline"
				>
					← Back to About
				</Link>
			</p>
		</div>
	);
}
